import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { allArticles } from "@/pages/Insights";
import { opportunities } from "@/data/projects";

const GROUPS = [
  {
    title: "Main",
    links: [
      { label: "Home", path: "/" },
      { label: "Destinations", path: "/destinations" },
      { label: "Current Opportunities", path: "/opportunities" },
      { label: "Selected Developments", path: "/developments" },
      { label: "Advisory", path: "/advisory" },
      { label: "Land, Development & JV", path: "/land-development-jv" },
      { label: "Insights", path: "/insights" },
      { label: "About ACRE", path: "/about" },
      { label: "Client Stories", path: "/client-stories" },
      { label: "Private Consultation", path: "/private-consultation" },
    ],
  },
  {
    title: "Destinations",
    links: [
      { label: "Dubai", path: "/destinations/dubai" },
      { label: "Abu Dhabi", path: "/destinations/abu-dhabi" },
      { label: "Ras Al Khaimah & Al Marjan Island", path: "/destinations/ras-al-khaimah" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", path: "/privacy-policy" },
      { label: "Terms of Use", path: "/terms-of-use" },
      { label: "Disclaimer", path: "/disclaimer" },
      { label: "Cookie Policy", path: "/cookie-policy" },
    ],
  },
];

const Sitemap = () => (
  <div data-testid="sitemap-page">
    <SEO title="Sitemap" description="A complete index of pages on the ACRE — Al Casa Real Estate website." path="/sitemap" />
    <PageHero eyebrow="Sitemap" title="Every page, one place" testid="sitemap-hero" />
    <section className="pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        {GROUPS.map((g) => (
          <div key={g.title}>
            <h2 className="text-xs uppercase tracking-[0.25em] text-[#C5A880] font-semibold mb-5">{g.title}</h2>
            <ul className="space-y-3">
              {g.links.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-[#9DA3AE] hover:text-[#E6CA65] transition-colors" data-testid={`sitemap-${l.path.replace(/\//g, "-") || "-home"}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <h2 className="text-xs uppercase tracking-[0.25em] text-[#C5A880] font-semibold mb-5">Opportunities</h2>
          <ul className="space-y-3">
            {opportunities.map((p) => (
              <li key={p.slug}>
                <Link to={`/opportunities/${p.slug}`} className="text-sm text-[#9DA3AE] hover:text-[#E6CA65] transition-colors">
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-xs uppercase tracking-[0.25em] text-[#C5A880] font-semibold mb-5">Insights</h2>
          <ul className="space-y-3">
            {allArticles.map((a) => (
              <li key={a.slug}>
                <Link to={`/insights/${a.slug}`} className="text-sm text-[#9DA3AE] hover:text-[#E6CA65] transition-colors">
                  {a.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  </div>
);

export default Sitemap;
